import React, { useState } from 'react';
import Button3D from '../ui/Button3D';
import { CompanyList } from './ChooseCompanyScreen';
import '../../styles/companyChoice.css';

// BL-408 G2: the platform side (app.smarteknowledgy.com) for a platform role holder with two or more companies and no
// company chosen in this sign-in session (Q-004: the switcher plus the platform admin links). Nothing company-specific
// is loaded here; choosing a company enters it on the server and reloads cleanly.
export const PLATFORM_LINKS = Object.freeze([
    { path: '/support-console', label: 'Support Console' },
    { path: '/platform-roles', label: 'Platform Roles' },
]);

export default function PlatformLanding({ companies, heading, footer, onChoose, onOpenLink, onSignOut, theme = 'light' }) {
    const [busyId, setBusyId] = useState(null);
    const [error, setError] = useState('');

    async function choose(company) {
        setBusyId(company.orgId);
        setError('');
        let result;
        try { result = await onChoose(company); } catch (failure) { result = { ok: false, reason: 'failed' }; }
        if (!result?.ok) {
            setBusyId(null);
            if (result?.reason !== 'mfa_required' && result?.reason !== 'sign_in_again') {
                setError('That company could not be opened. Choose another one or try again.');
            }
        }
    }

    return (
        <div className="tenant-sign-in ia-mcs flex min-h-screen items-center justify-center p-6" data-theme={theme}>
            <div className="w-full max-w-md">
                <header className="tenant-brand"><p className="ia-mcs-platform-name">{heading}</p></header>
                <section className="ia-mcs-card" aria-labelledby="ia-mcs-platform-heading">
                    <h1 id="ia-mcs-platform-heading" className="ia-mcs-heading">Platform</h1>
                    <h2 className="ia-mcs-subheading">Open a company</h2>
                    <CompanyList companies={companies} busyId={busyId} onChoose={choose} />
                    {error && <p role="alert" className="ia-mcs-error">{error}</p>}
                    <h2 className="ia-mcs-subheading">Platform admin</h2>
                    <nav aria-label="Platform admin" className="ia-mcs-links">
                        {PLATFORM_LINKS.map((link) => (
                            <Button3D key={link.path} variant="light" disabled={Boolean(busyId)} onClick={() => onOpenLink(link.path)}>{link.label}</Button3D>
                        ))}
                    </nav>
                    <Button3D variant="light" className="ia-mcs-signout" disabled={Boolean(busyId)} onClick={onSignOut}>Sign out</Button3D>
                </section>
            </div>
            {footer && <footer className="tenant-sign-in-footer">{footer}</footer>}
        </div>
    );
}
